/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_AltInputs */

const en_mk_proof_panel_alt = /** @type {(inputs: Mk_Proof_Panel_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep evidence panel: four criteria passed, the commit attached, the task verified — and a first attempt that the server refused`)
};

const id_mk_proof_panel_alt = /** @type {(inputs: Mk_Proof_Panel_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel bukti Bystep: empat kriteria lulus, commit terlampir, task terverifikasi — plus percobaan pertama yang ditolak server`)
};

/**
* | output |
* | --- |
* | "Bystep evidence panel: four criteria passed, the commit attached, the task verified — and a first attempt that the server refused" |
*
* @param {Mk_Proof_Panel_AltInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_alt = /** @type {((inputs?: Mk_Proof_Panel_AltInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_AltInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_alt(inputs)
	return en_mk_proof_panel_alt(inputs)
});